// import { useEffect, useState } from "react";
// import { Badge, Button, Col, Form, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

// import { toast } from "react-toastify";

// import { useForm } from "react-hook-form";
// import Head from "../../../layout/head/Head";
// import Content from "../../../layout/content/Content";
// import {
//   Block,
//   BlockBetween,
//   BlockHead,
//   BlockHeadContent,
//   BlockTitle,
//   Icon,
//   PreviewAltCard,
// } from "../../../components/Component";
// import MySelect from "../../../MyComp/UI/form/MySelect";
// import MyInput from "../../../MyComp/UI/form/MyInput";

// import DeleteModal from "../../../MyComp/UI/modals/DeleteModal";
// import ConfirmModal from "../../../MyComp/UI/modals/ConfirmModal";
// import MyButton from "../../../MyComp/UI/form/MyButton";
// import useLogout from "../../../hooks/useLogout";
// import ViewImgAndPdf from "../../ImageFolder/ViewImageAndPdf";
// import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";
// import Status from "../../../MyComp/UI/form/Status";
// import { BASE_EXCEL_URL, BASE_URL_IMG } from "../../../assets/constants";
// import { UserAvatarCell } from "../../../MyComp/ImageView/UserAvatarCell";
// import {
//   createPackageAPI,
//   createPackageLabAPI,
//   deleteLabPackageAPI,
//   deletePackageAPI,
//   getPackageLabList,
//   getPackageListAPI,
//   updateGroupAPI,
//   updatePackageAPI,
//   updatePackageLabAPI,
//   uploadPackageCatalogAPI,
//   uploadTestCatalog,
// } from "../../../api/master/indes";
// import {
//   categoryPackageDDAPI,
//   categoryTestDDAPI,
//   getSubgorupDDAPI,
//   subMultipleCategoryDDAPI,
// } from "../../../api/dropdown";
// import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
// import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
// import DiscountValidation from "../../../MyComp/UI/form/DiscountValidation";

// const LaboratoryPackage = () => {
//   const {
//     register,
//     handleSubmit,
//     setValue,
//     watch,
//     trigger,
//     clearErrors,
//     getValues,
//     setError,
//     reset,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       isLoading: false,
//       addSub: false,
//       package_img:null,
//       package_image:null,
//       data: [],
//     },
//   });
//   const logout = useLogout();
//   const [isOpen, setIsOpen] = useState(false);
//   const [mode, setMode] = useState("Add");
//   const isLoading = watch("isLoading");
//   const data = watch("data");
//   const [imageOpen, setImageOpen] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const discountType = [
//     { value: "percentage", label: "percentage" },
//     {
//       value: "fixed",
//       label: "fixed",
//     },
//   ];
//   // Table Columns
//   const [column, setColumn] = useState([
//     {
//       name: "Image",
//       selector: (row) => (
//         <div>
//           {/* <img
//             style={{ width: "50px", height: "50px", borderRadius: "6px" }}
//             src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
//           /> */}
//           <UserAvatarCell
//             row={row}
//             name={row?.package_name}
//             handleImageOpenPreview={handleImageOpenPreview}
//             image={`${BASE_URL_IMG}${row.image}`}
//           />
//         </div>
//       ),
//       sortable: false,
//       wrap: true,
//     },
//     {
//       name: "Name",
//       selector: (row) => row?.package_name,
//       sortable: true,
//     },
//     {
//       name: "Description",
//       selector: (row) => row?.package_description,
//       sortable: true,
//       wrap: true,
//     },
//     {
//       name: "Price",
//       selector: (row) => row?.package_price,
//       sortable: true,
//     },
//      {
//       name: "Discount",
//       selector: (row) => row?.discount,
//       sortable: true,
//     },
//         {
//       name: "Discount Type",
//       selector: (row) => row?.discountType,
//       sortable: true,
//     },

//      {
//       name: "Net",
//       selector: (row) => row?.Net,
//       sortable: true,
//     },

//     //  {
//     //   name: "Package Details",
//     //   selector: (row) => row?.details,
//     //   sortable: true,
//     // },
//     {
//       name: "Status",
//       selector: (row) => row?.status,
//       cell: (row) => (
//         <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
//           <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
//         </div>
//       ),
//       sortable: true,
//       wrap: true,
//       // width: "90px",
//     },
//     {
//       name: "Action",
//       wrap: true,
//       width: "120px",
//       cell: (row) => (
//         <div>
//           <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
//             <Icon name="edit" />
//           </Button>
//           <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
//             <Icon name="trash" onClick={() => handleDeleteClick(row)} />
//           </Button>
//         </div>
//       ),
//     },
//   ]);

//   // Fetch group list

//   useEffect(() => {
//     // if (watch("categoryDD")?.length < 1) {
//     //   getCategory();
//     // }
//     getPackageList();
//   }, []);

//   const getPackageList = () => {
//     setLoading(true);
//     getPackageLabList({ labId: labId })
//       .then((res) => {
//         if (res.data.status === true) {
//           setValue("data", res.data.data);
//         } else if (res.data.status === "expired") {
//           toast.error(res.data.message);
//           logout();
//         } else {
//           toast.error(res.data.message);
//         }
//       })
//       .catch((err) => {
//         setLoading(false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const onFormSubmit = async (data) => {
//     try {
//       // setIsLoading(true);
//       setValue("isLoading", true);
//       const formData = new FormData();

//       //    const desc = watch("package_description");
//       // if (Array.isArray(desc)) {
//       //   formData.append("package_description", JSON.stringify(desc.map((d) => d.label)));
//       // }
//       formData.append("discountType", data?.discount_type?.value);
//       formData.append("Net", data?.net);
//       formData.append("package_price", Number(data?.price));
//       // formData.append("package_description", data?.package_description);
//       formData.append("labId", localStorage.getItem("userId"));

//       // formData.append("package_name", data?.package_name?.value);

//       if (data?.package_name?.value) {
//         formData.append("package_name", data.package_name.label);
//       }

//       formData.append("discount", Number(data?.discount));
//       const desc = watch("description");
//       if (Array.isArray(desc)) {
//         formData.append("package_description", JSON.stringify(desc.map((d) => d.label)));
//       }

//       // Status
//       const status = watch("status");
//       if (status?.value) {
//         formData.append("Status", status.value);
//       }
//       const imgFile = watch("package_img");
//       if (imgFile) {
//         formData.append("image", imgFile);
//       }
//       // Name & Price
//       // formData.append("Category", watch("category"));
//       // formData.append("Type", watch("type"));

//       if (mode === "Edit") {
//         formData.append("id", watch("selectedRow")?.id);
//       }

//       // Debug FormData

//       // return false;
//       const res = mode === "Add" ? await createPackageLabAPI(formData) : await updatePackageLabAPI(formData);

//       if (res?.data?.status === true) {
//         toast.success(res.data.message);
//         getPackageList();
//         resetF();
//            setMode("Add");
//         setIsOpen(false);
//         // getPackageList()
//       } else {
//         toast.error(res?.data?.message || "Operation failed");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error(err?.response?.data?.message || "Something went wrong");
//     } finally {
//       // setIsLoading(false);
//       setValue("isLoading", false);
//       getPackageList();
//     }
//   };

//   const handleEdit = (row) => {
//     window.scrollTo(0, 0);

//     setIsOpen(true);
//     setMode("Edit");

//     // Store full row for update API
//     setValue("selectedRow", row);
// setValue("net",row.Net)
// setValue("discount",row.discount)
//     // Package Name
//     // setValue("package_name", row?.package_name || "");
//     setValue("package_name", {
//       label: row.package_name,
//       value: row.package_name,
//     });
//     // setValue("package_name", {value:row?.package_name.label,label:row?.package_name.label} || "");
//     setValue("category", row?.category || "");

//     // Package Price
//     setValue("price", row?.package_price || "");
//     setValue("net", row?.Net || "");

//     // Discount Type (MySelect expects {label, value})
//     setValue(
//       "discount_type",
//       [
//         { value: "percentage", label: "percentage" },
//         { value: "fixed", label: "fixed" },
//       ].find((item) => item.value === row?.discountType) || null,
//     );

//     // Discount
//     // setValue("discount", row?.discount || 0);  

//     // Description (TextArea → STRING, not array)
//     // setValue("description", {label:row?.package_description ,value:row?.package_description}|| "");
//     const descriptionArray = row?.package_description
//       ? row.package_description
//           .replace(/^[^:]+:\s*/, "") // remove text before colon safely
//           .split(",")
//           .map((item) => ({
//             label: item.trim(),
//             value: item.trim(),
//           }))
//       : [];

//     setValue("description", descriptionArray);

//     setValue("description", descriptionArray);

//     // Status
//     setValue("status", {
//       label: row?.status ? "Active" : "Inactive",
//       value: row?.status,
//     });

//     // Image Preview
//     // setValue(
//     //   "package_image",
//     //   row?.image ? `${BASE_URL_IMG}${row.image}` : null
//     // );
//     setValue("package_image", `${BASE_URL_IMG}${row.image}`);

//     // File input must be null on edit
//     // setValue("package_img", null);
//   };

//   console.log(errors, "errors");
//   const handleToggleStatus = (row) => {
//     setValue("selectedRow", row);
//     setShowModal(true);
//   };

//   const confirmStatusChange = async () => {
//     const updatedStatus = !watch("selectedRow").status;
//     // setValue("isLoading", true);
//     const formObject = {
//       //   id: watch("selectedRow").id,
//       //api not available for status change in group using id
//       status: updatedStatus,
//     };

//     try {
//       const res = await updateGroupAPI(formObject);
//       if (res.data.status === true) {
//         // toast.success(res.data.message);
//         // await getPackageList();
//       } else if (res.data.status === "expired") {
//         // toast.error(res.data.message);
//         logout();
//       } else {
//         // toast.error(res.data.message);
//       }
//     } catch (err) {
//       // toast.error(err?.response?.data?.message);
//     } finally {
//       setValue("isLoading", false);
//       setShowModal(false);
//     }
//   };

//   const handleImageOpenPreview = (row) => {
//     // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
//     setValue("image_preview", row);
//     setImageOpen(true);
//   };

//   const [loading, setLoading] = useState(false);
//   const resetF = () => {
//     setValue("package_image", "");
//     setValue("description", null);
//     setValue("package_price", null);
//     setValue("package_image", null);
//     setValue("package_description", "");
//     setValue("package_name", "");
//     setValue("discountType", null);
//     setValue("discount", null);
//     setValue("status", null);
//     setValue("category", null);
//     setValue("subCategory", null);
//     // setValue("type", null);
//     setValue("image_preview", null);
//     setValue("package-detail", null);
//     setValue("price", null);
//     setValue("package_img", null);
//   };

//   const handleImageClose = () => {
//     setImageOpen(false);
//   };
//   const handleDeleteClick = (row) => {
//     // setSelectedRow(row);
//     setValue("selectedRow", row);
//     setShowDeleteModal(true);
//   };

//   const confirmDelete = () => {
//     if (!watch("selectedRow")) return;

//     deleteLabPackageAPI({ id: watch("selectedRow").id })
//       .then((res) => {
//         // setLoading(false);
//         setShowDeleteModal(false);
//         if (res.data.status === true) {
//           toast.success(res.data.message);
//           //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
//           setValue(
//             "data",
//             watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
//           );
//         } else if (res.data.status === "expired") {
//           toast.error(res.data.message);
//           logout();
//         } else {
//           toast.error(res.data.message);
//         }
//       })
//       .catch((err) => {
//         // setLoading(false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
//   useEffect(() => {
//     getCategory();
//   }, [mode]);
//   const getCategory = () => {
//     categoryTestDDAPI()
//       .then((res) => {
//         //const status = decrypt(res.data.status);
//         if (res.data.status === true) {
//           // toast.success(res.data.message);
//           toast.clearWaitingQueue();
//           setValue("categoryDD", res.data.data);
//           setValue("isLoading", false);
//         } else if (res.data.status === false) {
//           setValue("isLoading", false);
//           setValue("categoryDD", []);
//           toast.error(res.data.message);
//           toast.clearWaitingQueue();
//         } else if (res.data.status === "expired") {
//           console.log("token expired", res.data);
//           setValue("isLoading", false);
//           toast.error(res.data.message);
//           toast.clearWaitingQueue();
//           logout();
//         }
//       })
//       .catch((err) => {
//         setValue("isLoading", false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
//   // useEffect(() => {
//   //   const categories = watch("category"); // array of selected categories

//   //   if (Array.isArray(categories) && categories.length > 0) {
//   //     // Extract all selected IDs
//   //     const categoryIds = categories.map((cat) => cat.value);
//   //     getSubCategory(categoryIds);
//   //   } else {
//   //     setValue("subCategoryDD", []);
//   //   }
//   // }, [watch("category")]);
//   useEffect(() => {
//     getSubCategory();
//   }, [mode]);
//   const getSubCategory = (categoryIds) => {
//     const body = { categoryIds };

//     getSubgorupDDAPI(body)
//       .then((res) => {
//         if (res.data.status === true) {
//           console.log(res.data.data, "hjjb");
//           const options = res.data.data.map((item) => ({
//             value: item.value,
//             label: item.label,
//           }));

//           setValue("subCategoryDD", options);
//         } else if (res.data.status === "expired") {
//           logout();
//         } else {
//           setValue("subCategoryDD", []);
//         }
//       })
//       .catch(() => {
//         setValue("subCategoryDD", []);
//       });
//   };
//   const {
//     clearErrors: clearErrorsTest,
//     register: registerTest,
//     handleSubmit: handleSubmitTest,
//     control: controlTest,
//     setValue: setValueTest,
//     watch: watchTest,
//     trigger: triggerTest,
//     formState: { errors: errorsTest },
//     reset: resetTest,
//     setError: setErrorTest,
//   } = useForm({
//     defaultValues: {
//       isLoading: false,
//       addSub: false,
//       data: [],
//     },
//     mode: "onChange",
//   });
//   const handleUploadClick = () => {
//     setDownloadModalOpen(true);
//   };
//   const labId = localStorage.getItem("userId");
//   const [downloadModalOpen, setDownloadModalOpen] = useState(false);
//   // New: Handle Upload click to show download modal
//   const uploadTestCatalogAPI = async () => {
//     try {
//       setUploading(true);
//       const file = watchTest("file");
//       if (!file) {
//         toast.errorsTest("Please select an Excel file");
//         return;
//       }
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("labId", labId);

//       const res = await uploadPackageCatalogAPI(formData);

//       if (res?.data?.status === "expired") {
//         toast.error(res.data.message);
//         toast.clearWaitingQueue();
//         logout();
//       } else if (res?.data?.status === true) {
//         toast.success(res.data.message || "Excel uploaded successfully");
//         handleCancel();
//         setDownloadModalOpen(false);

//         getPackageList();
//         setValueTest("data", res.data.data || []);
//       } else {
//         toast.error(res?.data?.message || "Upload failed");
//       }
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Upload failed");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const selectedFile = e.target.files[0];

//     if (!selectedFile) {
//       setValueTest("file", null);
//       setErrorTest("file", { type: "manual", message: "File is required" });
//       return;
//     }

//     validateExcel(selectedFile, (isValid) => {
//       if (isValid) {
//         clearErrorsTest("file");
//         setValueTest("file", selectedFile);
//       } else {
//         setValueTest("file", null);
//         setErrorTest("file", { type: "manual", message: "Invalid file type. Please upload a valid Excel file." });
//         toast.error("Invalid file type. Please upload a valid Excel file.");
//         e.target.value = null;
//       }
//     });
//   };
//   useEffect(() => {
//     if (!downloadModalOpen) {
//       setValueTest("file", null);
//       clearErrorsTest("file");

//       // reset actual file input DOM value
//       const input = document.getElementById("fileInput");
//       if (input) {
//         input.value = "";
//       }
//     }
//   }, [downloadModalOpen]);
//   const handleCancel = () => {
//     setValueTest("file", null);
//     clearErrorsTest("file");

//     const input = document.getElementById("fileInput");
//     if (input) {
//       input.value = "";
//     }
//   };

//   // const handleCancel = () => {
//   //   setValue("file", null);
//   //   clearErrors("file");
//   // };
//   const validateExcel = (file, callback) => {
//     const reader = new FileReader();

//     const fileName = file.name.toLowerCase();
//     const isXlsExtension = fileName.endsWith(".xls");
//     const isXlsxExtension = fileName.endsWith(".xlsx");

//     if (!isXlsExtension && !isXlsxExtension) {
//       callback(false);
//       return;
//     }

//     reader.onloadend = function (event) {
//       const arr = new Uint8Array(event.target.result).subarray(0, 4);
//       let header = "";
//       for (let i = 0; i < arr.length; i++) {
//         header += arr[i].toString(16).padStart(2, "0");
//       }
//       header = header.toUpperCase();

//       const isXls = header === "D0CF11E0"; // XLS
//       const isXlsx = header === "504B0304"; // XLSX
//       const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);

//       callback(isExcel);
//     };

//     reader.onerror = function () {
//       callback(false);
//     };

//     reader.readAsArrayBuffer(file.slice(0, 4));
//   };
//   const [uploading, setUploading] = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);

//   // const handleSampleFileOpen = () => {
//   //   const upload = "upload-package-catalog";
//   //   const fileName = `${BASE_URL_IMG}${upload}`;
//   //   // Replace 'sample_file.txt' with the name of your sample file
//   //   // const fileName = watch("file_name");
//   //   var filePath;
//   //   // Path to your sample file
//   //   // if (selectedType?.value == "facility") {
//   //   filePath = ` ${watch("file_name")}`; // Update the path
//   //   // } else {
//   //   //   filePath = `${base}${sampelFileV2}`; // Update the path
//   //   // }
//   //   const link = document.createElement("a");
//   //   link.href = filePath;
//   //   link.download = fileName;
//   //   document.body.appendChild(link);
//   //   link.click();
//   //   document.body.removeChild(link);
//   // };
//   const handleSampleFileOpen = () => {
//     const fileUrl = "http://192.168.23.11:3002/uploads/package-catalog.xlsx";

//     const link = document.createElement("a");
//     link.href = fileUrl;
//     link.download = "package-catalog.xlsx"; // forces download

//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // useEffect(() => {
//   //   const categories = watch("category"); // array of selected categories

//   //   if (Array.isArray(categories) && categories.length > 0) {
//   //     // Extract all selected IDs
//   //     const categoryIds = categories.map((cat) => cat.value);
//   //     getSubDDCategory(categoryIds);
//   //   } else {
//   //     setValue("subCategoryDD", []);
//   //   }
//   // }, [watch("category")]);

//   const getSubDDCategory = (categoryIds) => {
//     const body = { categoryIds };

//     subMultipleCategoryDDAPI(body)
//       .then((res) => {
//         if (res.data.status === true) {
//           const options = res.data.data.map((item) => ({
//             value: item.value,
//             label: item.label,
//           }));

//           setValue("subCategoryDD", options);
//         } else if (res.data.status === "expired") {
//           logout();
//         } else {
//           setValue("subCategoryDD", []);
//         }
//       })
//       .catch(() => {
//         setValue("subCategoryDD", []);
//       });
//   };
//   useEffect(() => {
//     getPackage();
//   }, [mode]);
//   const getPackage = () => {
//     categoryPackageDDAPI()
//       .then((res) => {
//         //const status = decrypt(res.data.status);
//         if (res.data.status === true) {
//           // toast.success(res.data.message);
//           toast.clearWaitingQueue();
//           setValue("packageDD", res.data.data);
//           setValue("isLoading", false);
//         } else if (res.data.status === false) {
//           setValue("isLoading", false);
//           setValue("packageDD", []);
//           toast.error(res.data.message);
//           toast.clearWaitingQueue();
//         } else if (res.data.status === "expired") {
//           console.log("token expired", res.data);
//           setValue("isLoading", false);
//           toast.error(res.data.message);
//           toast.clearWaitingQueue();
//           logout();
//         }
//       })
//       .catch((err) => {
//         setValue("isLoading", false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
//   console.log(BASE_EXCEL_URL, "BASE_EXCEL_URL");
//     useEffect(() => {
//     const price = watch("price");
//     const discount = watch("discount");
//     const discountType = watch("discount_type");

//     if (price && discount && discountType) {
//       let netPrice = parseFloat(price);
//       const discountValue = parseFloat(discount);

//       if (discountType.value === "percentage") {
//         netPrice = price - price * (discountValue / 100);
//       } else if (discountType.value === "fixed") {
//         netPrice = price - discountValue;
//       }

//       netPrice = Math.max(0, netPrice);

//       setValue("net", netPrice.toFixed(2));

//       trigger("net");
//     } else {
//       setValue("net", "");
//     }
//   }, [watch("price"), watch("discount"), watch("discount_type")]);
//   return (
//     <>
//       <Head title="Group | Master" />
//       <Content>
//         <BlockHead size="sm" className="mb-0 pb-0">
//           <BlockBetween>
//             <BlockHeadContent>
//               <BlockTitle page tag="h3">
//                 Manage Package
//               </BlockTitle>
//             </BlockHeadContent>
//             <BlockHeadContent>
//               <>
//                 {/* <Button color="primary" outline style={{ marginRight: "15px" }} onClick={handleUploadClick}>
//                   <Icon name="upload" />
//                 </Button> */}
          
//                   <Button
//                     color="primary"
//                     outline
//                     className="me-n1"
//                     onClick={() => {
//                       setIsOpen((pre) => !pre);
//                       setMode("Add");
//                       resetF();
//                     }}
//                   >
//                     <Icon name={isOpen ? "minus" : "plus"} />
//                   </Button>
          
//               </>
//             </BlockHeadContent>
//           </BlockBetween>
//         </BlockHead>

//         <Block className="pt-0">
//           {isOpen && (
//             <PreviewAltCard>
//               <Form onSubmit={handleSubmit(onFormSubmit)}>
//                 <Row>
//                   {/* <Col md="3">
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Discount Type"
//                       name="discountType"
//                       placeholder="Select discount type"
//                       required
//                       options={discountType}
//                       disabled={mode === "Approval"}
//                     />
//                   </Col> */}
                  
//                   {/* <Col md="3" className={``}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Group"}
//                       name={"category"}
//                       placeholder={"Select Group"}
//                       required
//                       options={watch("categoryDD")}
//                       multi
//                     />
//                   </Col> */}
//                   <Col md="4">
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Package"}
//                       name={"package_name"} 
//                       placeholder={"Select Package"}
//                       required
//                       options={watch("packageDD")}
//                     />
//                   </Col>
//                   <Col md="4" className={``}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Description"}
//                       name={"description"}
//                       placeholder={"Select Sub Group"}
//                       required
//                       options={watch("subCategoryDD")}
//                       multi
//                     />
//                   </Col>

//                   {/* <Col md="3">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Package Name"
//                       name="package_name"
//                       placeholder="Enter Package Name "
//                       required
//                       // min={2}
//                       // max={50}
//                       disabled={watch("addSub")}
//                     />
//                   </Col> */}
//                   {/* <Col md="4">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Package Price"
//                       name="package_price"
//                       placeholder="Enter MRP"
//                       required
//                       pattern={/^[0-9]+$/}
//                       patternMsg="Only numbers are allowed"
//                       disabled={watch("addSub")}
//                     />
//                   </Col> */}

//                   {/* <Col md="3" className={``}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Category "}
//                       name={"category"}
//                       placeholder={"Select Group"}
//                       required
//                       options={watch("categoryDD")}
//                       multi
//                     />
//                   </Col> */}


//                   {/* <Col md="3" className={``}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Description"}
//                       name
                      
//                       <Col md="3">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Category"
//                       name="category"
//                       placeholder="Enter Category"
//                       required
//                     />
//                   </Col>

//                   <Col md="3">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Category Type"
//                       name="type"
//                       placeholder="Enter Category type "
//                       required
//                     />
//                   </Col>
//                   {/* <Col md={2}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Type"}
//                       name={"type"}
//                       placeholder={"Select type"}
//                       required
//                       options={[
//                         { value: "percentage", label: "Percentage" },
//                         { value: "fixed", label: "Fixed" },
//                       ]}
//                     />
//                   </Col> */}
//                    <Col md="4">
//                                       <MyInput
//                                         register={register}
//                                         watch={watch}
//                                         setValue={setValue}
//                                         trigger={trigger}
//                                         errors={errors}
//                                         title="Price"
//                                         name="price"
//                                         placeholder="Enter price"
//                                         required
//                                         min={0.01}
//                                         validation={{
//                                           validate: (value) => {
//                                             if (value <= 0) return "Price must be greater than 0";
//                                             return true;
//                                           },
//                                         }}
//                                       />
//                                     </Col>
//                   <Col md={4}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Type"}
//                       name={"discount_type"}
//                       placeholder={"Select type"}
//                       required
//                       options={[
//                         { value: "percentage", label: "percentage" },
//                         { value: "fixed", label: "fixed" },
//                       ]}
//                     />
//                   </Col>

//                   <Col md="4" className={``}>
//                     <DiscountValidation
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Discount"}
//                       name={"discount"}
//                       placeholder={"Enter discount"}
//                       required
//                       minNum={0} 
                     
//                       validate={(value) => {
//                         const type = watch("discount_type")?.value;
//                         const price = watch("price");

//                         if (!value) return true; 

//                         const discountValue = parseFloat(value);
//                         const priceValue = parseFloat(price);

//                         if (isNaN(discountValue)) return "Please enter a valid number";

//                         if (!price || isNaN(priceValue) || priceValue <= 0) {
//                           return "Please enter a valid price first";
//                         }

//                         if (type === "percentage") {
//                           if (discountValue < 0) return "Percentage cannot be negative";
//                           if (discountValue > 100) return "Percentage cannot exceed 100%";

//                           // Calculate actual discount amount
//                           const discountAmount = (priceValue * discountValue) / 100;
//                           if (discountAmount >= priceValue) {
//                             return "Discount amount must be less than price";
//                           }
//                         } else if (type === "fixed") {
//                           if (discountValue < 0) return "Discount cannot be negative";
//                           if (discountValue >= priceValue) {
//                             return "Fixed discount must be less than price";
//                           }
//                         } else {
//                           return "Please select a discount type first";
//                         }

//                         return true;
//                       }}
//                     />
//                   </Col>
//                   <Col md="4" className={``}>
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Net"}
//                       name={"net"}
//                       placeholder={"Auto-calculated"}
//                       readOnly
//                       disabled
//                     />
//                   </Col>

//                   {/* <Col md="2" className={``}>
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Minimum Amount"}
//                       name={"min_amount"}
//                       placeholder={"Enter minimum amount to avail coupon"}
//                       required
//                       min={1}
//                       max={3}
//                     />
//                   </Col>*/}

//                   {/* <Col md="2" className={``}>
//                     <MyDate
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Start Date"}
//                       name={"start_date"}
//                       placeholder={"Enter start date"}
//                       required
//                       min={moment().add(0, "days").toDate()}
//                       max={moment().add(1, "years").toDate()}
//                       time
//                       format={"MM/dd/yyyy h:mm aa"}
//                     />
//                   </Col> */}
//                   {/* <Col md="2" className={``}>
//                     <MyDate
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Expiry Date"}
//                       name={"exp_date"}
//                       placeholder={"Enter expiry date"}
//                       required
//                       min={moment().add(1, "days").toDate()}
//                       max={moment().add(1, "years").toDate()}
//                       time
//                       format={"MM/dd/yyyy h:mm aa"}
//                     />
//                   </Col> */}

//                   {/* <Col md="2" className={``}>
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Category"}
//                       name={"category"}
//                       placeholder={"Select category"}
//                       required
//                       options={watch("categoryDD")}
//                       multi
//                     />
//                   </Col> */}
                    
          
//                   {/* <Col md="4">
//                     <MySelect
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Discount Type"
//                       name="discountType"
//                       placeholder="Select discount type"
//                       required
//                       options={discountType}
//                       disabled={mode === "Approval"}
//                     />
//                   </Col>
//                     <Col md="4" className={``}>
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Net"}
//                       name={"Net"}
                    
//                       patternMsg="Only numbers are allowed"
//                       placeholder={"Enter"}
               
//                     />
//                   </Col> */}
//                   {/* <Col md="4" className={``}>
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Discount"}
//                       name={"discount"}
                    
//                       patternMsg="Only numbers are allowed"
//                       placeholder={"Enter  discount"}
//                       required
//                       min={1}
//                     />
//                   </Col> */}
//                   {/* <Col md="3">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Pacakge Details"
//                       name="package-detail"
//                       placeholder="Enter package details"
//                       required
//                     />
//                   </Col> */}
//                   {/* <Col md="3">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Description"
//                       name="description"
//                       placeholder="Enter description"
//                       required
//                     />
//                   </Col> */}
//                   {/* <Col md="3">
//                     <MyInput
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title="Price"
//                       name="price"
//                       placeholder="Enter price"
//                       required
//                       // min={1}
//                       // max={watch("type")?.value == "percentage" ? 2 : 3}
//                     />
//                   </Col> */}
//                      <Col md="3">
//                       <ImageUpload
//                         name="package_image"
//                         id="package_image"
//                         watch={watch}
//                         label="Upload Package Image"
//                         errors={errors}
//                         register={register}
//                         trigger={trigger}
//                         clearErrors={clearErrors}
//                         image="package_img"
//                         setError={setError}
//                         image_url="package_image"
//                         setValue={setValue}
//                         handleImageOpenPreview={handleImageOpenPreview}
//                         required
//                         getValues={getValues}
//                       />
//                     </Col> 
//                   <Col md="4">
//                     <Status
//                       register={register}
//                       watch={watch}
//                       // name={"status"}
//                       title={"Status"}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                     />
//                   </Col>
                        
//                   {/* <Col md="12" className={``}>
//                     <MyTextArea
//                       register={register}
//                       watch={watch}
//                       setValue={setValue}
//                       trigger={trigger}
//                       errors={errors}
//                       title={"Description"}
//                       name={"package_description"}
//                       placeholder={"Tell us something about you"}
//                       // required
//                       // min={25}
//                       // max={500}
//                       cols={2}
//                       row={2}
//                       disabled={mode == "Approval"}
//                     />
//                   </Col> */}
//                 </Row>{" "}
//                 <Col md="4">
//                   <MyButton isLoading={isLoading} mode={mode} />
//                 </Col>
//               </Form>
//             </PreviewAltCard>
//           )}

//           <MyDataTable data={data || []} columns={column} title="Package List" isLoading={isLoading} />
//         </Block>
//       </Content>
//       <DeleteModal
//         showDeleteModal={showDeleteModal}
//         setShowDeleteModal={setShowDeleteModal}
//         confirmDelete={confirmDelete}
//         selectedRow={watch("selectedRow")}
//         loading={isLoading}
//       />
//       <ConfirmModal
//         isOpen={showModal}
//         toggle={() => setShowModal(!showModal)}
//         onConfirm={confirmStatusChange}
//         status={watch("selectedRow")?.status}
//       />

//       <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
//       <Modal isOpen={downloadModalOpen} toggle={() => setDownloadModalOpen(false)} centered>
//         <ModalHeader toggle={() => setDownloadModalOpen(false)}>Upload Test Catalog (Excel)</ModalHeader>

//         <ModalBody>
//           <div className="d-block justify-content-between">
//             <div
//               style={{
//                 // maxWidth:'250px',
//                 border: "2px dashed #cfd4da",
//                 borderRadius: "10px",
//                 padding: "5px",
//                 textAlign: "center",
//                 background: "#f8f9fa",
//               }}
//             >
//               {watchTest("file") ? (
//                 <div
//                   style={{
//                     border: "1px solid #dee2e6",
//                     borderRadius: "10px",
//                     padding: "20px",
//                     background: "#ffffff",
//                   }}
//                 >
//                   <Icon name="file-excel" style={{ fontSize: "28px", color: "green" }} />
//                   <p
//                     style={{
//                       marginTop: "10px",
//                       wordBreak: "break-word",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {watchTest("file")?.name}
//                   </p>

//                   <div className="d-flex justify-content-center gap-2 mt-3">
//                     <Button color="danger" size="sm" className="p-2" outline onClick={handleCancel}>
//                       Remove
//                     </Button>
//                     <Button
//                       className="p-2"
//                       color="primary"
//                       size="sm"
//                       disabled={uploading}
//                       onClick={uploadTestCatalogAPI}
//                     >
//                       {/* {uploading ? "Uploading..." : "Upload"} */}
//                       {"Upload"}
//                     </Button>
//                   </div>
//                 </div>
//               ) : (
//                 /* FILE INPUT */
//                 <>
//                   <label
//                     htmlFor="fileInput"
//                     style={{
//                       cursor: "pointer",
//                       display: "block",
//                     }}
//                   >
//                     <Icon name="upload" style={{ fontSize: "30px", color: "#0d6efd" }} />
//                     <p style={{ marginTop: "5px", fontWeight: "500" }}>Click to upload test catalog</p>
//                     {/* <small style={{ color: "#6c757d" }}>
//               Supported formats: .xls, .xlsx
//             </small> */}
//                   </label>

//                   <input
//                     type="file"
//                     id="fileInput"
//                     accept=".xls,.xlsx"
//                     style={{ display: "none" }}
//                     {...registerTest("file", { requiredTest: "File is required" })}
//                     onChange={handleChange}
//                   />

//                   {errorsTest.file && (
//                     <div style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{errorsTest.file.message}</div>
//                   )}
//                 </>
//               )}
//             </div>

//             {/* SAMPLE DOWNLOAD */}
//             <div
//               style={{
//                 border: "2px,solid,lightgray",
//                 borderRadius: "10px",
//                 paddingLeft: "50px",
//                 marginBottom: "10px",
//                 paddingTop: "15px",
//                 paddingRight: "25px",
//                 paddingBottom: "15px",
//                 marginTop: "10px",
//                 textAlign: "center",
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "6px",
//                 alignItems: "center",
//               }}
//             >
//               <small style={{ color: "crimson" }}>Download sample Excel</small>

//               {/* <Button size="sm" color="primary" outline onClick={handleSampleFileOpen}> */}

//               <a href={`${BASE_EXCEL_URL}/upload-package-catalog`} download>
//                 <button className="btn btn-outline-primary btn-sm">
//                   <Icon name="download" className="me-1" />
//                   Sample
//                 </button>
//               </a>
//             </div>
//           </div>
//         </ModalBody>
//       </Modal>
//     </>
//   );
// };

// export default LaboratoryPackage;
import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../../assets/constants";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";

import Status from "../../../MyComp/UI/form/Status";
import MyButton from "../../../MyComp/UI/form/MyButton";
import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";

import {
  createDiseaseAPI,
  createGroupAPI,
  createPackageAPI,
  deleteLabCategory,
  deletePackageAPI,
  deleteTestCategory,
  getPackageAPIList,
  getPackageListAPI,
  listDiseaseAPI,
  listGroupAPI,
  updateDiseaseAPI,
  updateGroupAPI,
  updatePackageAPI,
} from "../../../api/master/indes";

import MyInput from "../../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../../ImageFolder/ViewImageAndPdf";
import useLogout from "../../../hooks/useLogout";
import { UserAvatarCell } from "../../../MyComp/ImageView/UserAvatarCell";
import DeleteModal from "../../../MyComp/UI/modals/DeleteModal";
import { categoryTestDDAPI, generateFileAPI, subCategoryDDAPI, subMultipleCategoryDDAPI } from "../../../api/dropdown";
import MyCreateSelect from "../../../MyComp/UI/form/MyCreateSelect";
import MySelect from "../../../MyComp/UI/form/MySelect";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import DiscountValidation from "../../../MyComp/UI/form/DiscountValidation";

const Package = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Table Columns
  const [column, setColumn] = useState([
    {
      name: "Image",
      selector: (row) => (
        <div>
          {/* <img
            style={{ width: "50px", height: "50px", borderRadius: "6px" }}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
          /> */}
          <UserAvatarCell
            row={row}
            name={row?.package_name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.image}`}
          />
        </div>
      ),
      sortable: false,
      wrap: true,
    },
    // {
    //   name: "Name",
    //   selector: (row) => row?.package_name,
    //   sortable: true,
    // },
      {
      name: "Name",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.package_name || "";

        return (
          <div
            title={fullAddress}   // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 20)}
          </div>
        );
      },
    },
    
    // {
    //   name: "Description",
    //   selector: (row) => row?.package_description,
    //   sortable: true,
    // },
    
 
       {
      name: "Price",
      selector: (row) => row?.package_price,
      sortable: true,
    },
       {
      name: "Discount",
      selector: (row) => row?.discount,
      sortable: true,
    },
    {
      name: "Net",
      selector: (row) => row?.Net,
      sortable: true,
      wrap: false,
      // cell: (row) => {
      //   const fullAddress = row?.package_description || "";

      //   return (
      //     <div
      //       title={fullAddress}   // full text on hover
      //       style={{
      //         maxWidth: "150px",
      //         overflow: "hidden",
      //         cursor: "pointer",
      //       }}
      //     >
      //       {truncateByCharacters(fullAddress, 20)}
      //     </div>
      //   );
      // },
    },
 
    {
      name: "Description",
      selector: (row) => row?.package_description,
      sortable: true,
    },

    //  {
    //   name: "Package Details",
    //   selector: (row) => row?.details,
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  // Fetch group list

  useEffect(() => {
    // if (watch("categoryDD")?.length < 1) {
    //   getCategory();
    // }
    getPackageList();
  }, []);

  const getPackageList = () => {
    setLoading(true);
    getPackageAPIList()
      .then((res) => {
        if (res.data.status === true) {
          setValue("data", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const onFormSubmit = async (data) => {
    try {
      // setIsLoading(true);
      setValue("isLoading", true);
      const formData = new FormData();

      // Debug
      console.log("Submitting...");

      // Status
      const status = watch("status");
      if (status?.value) {
        formData.append("status", status.value);
      }

      // Image
      // const imgFile = watch("package_image");
      // if (imgFile instanceof File) {
      //   formData.append("package_image", imgFile);
      // }
      const imgFile = watch("package_img");
      if (imgFile) {
        formData.append("image", imgFile);
      }
      // Name & Price
      formData.append("name", watch("name"));
      formData.append("Net", watch("net"));
      formData.append("price", watch("price"));
      formData.append("discountType", data?.discount_type?.value);
      // formData.append("discount_type", watch("discount_type"));
      formData.append("discount", watch("discount"));
      formData.append("package_description", watch("package_description"));

      // Description
      const desc = watch("description");
      if (Array.isArray(desc)) {
        formData.append("description", JSON.stringify(desc.map((d) => d.label)));
      }

      // Edit mode
      if (mode === "Edit") {
        formData.append("id", watch("selectedRow")?.id);
      }

      // Debug FormData
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const res = mode === "Add" ? await createPackageAPI(formData) : await updatePackageAPI(formData);

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        await getPackageList();
        resetF();

        setIsOpen(false);
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      // setIsLoading(false);
      setValue("isLoading", false);
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("name", row?.package_name);
    setValue("package-detail", row?.details);
    setValue("discount", row?.discount);
    setValue("Net", row?.Net);
    setValue("package_description", row?.package_description);
    setValue("start_date", new Date(row.startDate));
    setValue("exp_date", new Date(row.endDate));
    setValue("discount_type", { label: row.discount_type, value: row.discount_type });
    setValue(
      "discount_type",
      [
        { value: "percentage", label: "percentage" },
        { value: "fixed", label: "fixed" },
      ].find((item) => item?.value == row?.discount_type),
    );
    setValue("package_image", `${BASE_URL_IMG}${row?.image}`); // preview URL
    setValue("package_img", null);
    setValue("value", row.discountValue);
    // setValue("description", row.package_description ? row.package_description.map((desc) => ({ label: desc, value: desc })) : []);
    // setValue("description", [{label:row.package_description.label,value:row.package_description.value}].find((item) => item?.value == row?.package_description?.value));
    setValue("code", row.code);
    // setValue("description", {label:row.package_description,value:row.package_description});
    setValue(
      "description",
      row.package_description.split(",").map((item) => ({
        label: item.trim(),
        value: item.trim(),
      })),
    );

    setValue("discount", row.discountValue);
    setValue("price", row.package_price);
    setValue("max_discount", row.maximum_discount_amount);
    setValue("order", row.order);
    setValue("Net", row.Net);
    setValue("discount", row.discount);
    setValue(
      "discountType",
      [
        { value: "percentage", label: "percentage" },
        { value: "fixed", label: "fixed" },
      ].find((item) => item.value === row?.discountType) || null,
    );

    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  console.log(errors, "errors");
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    // setValue("isLoading", true);
    const formObject = {
      //   id: watch("selectedRow").id,
      //api not available for status change in group using id
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getPackageList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const [loading, setLoading] = useState(false);
  const resetF = () => {
    setValue("package_image", null);
    setValue("description", "");
    setValue("name", "");
    setValue("status", null);
    setValue("category", null);
    setValue("subCategory", null);
    setValue("discount_type", null);
    setValue("discount", null);
    setValue("net", null);
    // setValue("", null);

    // setValue("type", null);
    setValue("image_preview", null);
    setValue("package-detail", null);
    setValue("price", null);
    setValue("package_img", null);
        clearErrors()
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    deletePackageAPI({ id: watch("selectedRow").id })
      .then((res) => {
        // setLoading(false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(()=>{
    getSubCategory();
  },[])
  useEffect(() => {
    const categories = watch("category"); // array of selected categories

    if (Array.isArray(categories) && categories.length > 0) {
      // Extract all selected IDs
      const categoryIds = categories.map((cat) => cat.value);
      getSubCategory(categoryIds);
    } else {
      setValue("subCategoryDD", []);
    }
  }, [watch("category")]);
  useEffect(()=>{
    getSubCategory();
  },[mode])

  const getSubCategory = (categoryIds) => {
    const body = { categoryIds };

    subMultipleCategoryDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const options = res.data.data.map((item) => ({
            value: item.value,
            label: item.label,
          }));

          setValue("subCategoryDD", options);
        } else if (res.data.status === "expired") {
          logout();
        } else {
          setValue("subCategoryDD", []);
        }
      })
      .catch(() => {
        setValue("subCategoryDD", []);
      });
  };
  const generateFile = () => {
    // const body = { categoryId };

    generateFileAPI()
      .then((res) => {
        console.log(res.data, "res.fileee");
        if (res.data.status === true) {
          // setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          // setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };


  useEffect(() => {
    const price = watch("price");
    const discount = watch("discount");
    const discountType = watch("discount_type");

    if (price && discount && discountType) {
      let netPrice = parseFloat(price);
      const discountValue = parseFloat(discount);

      if (discountType.value === "percentage") {
        netPrice = price - price * (discountValue / 100);
      } else if (discountType.value === "fixed") {
        netPrice = price - discountValue;
      }



      netPrice = Math.max(0, netPrice);

      setValue("net", netPrice.toFixed(2));

      trigger("net");
    } else {
      setValue("net", "");
    }
  }, [watch("price"), watch("discount"), watch("discount_type")]);
  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";

    return text.length > charLimit
      ? text.slice(0, charLimit) + "..."
      : text;
  };
  return (
    <>
      <Head title="Group | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Package
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className={"me-2"}>
              <div className="me-2 d-flex g-5">
                {/* <Button
                  color="primary"
                  outline
                  className="me-n1 me-2 pe-2"
                  onClick={() => {
                    generateFile();
                    resetF();
                  }}
                >
                  <Icon name={"file"} />
                </Button> */}
                <Button
                  color="primary"
                  outline
                  className="me-n1  mx-2"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Name"
                      name="name"
                      placeholder="Enter Name"
                      required
                    />
                  </Col>

                  {/* <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select Group"}
                      // required
                      options={watch("categoryDD")}
                      multi
                    />
                  </Col> */}
{/* 
                  <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Sub Group"}
                      name={"description"}
                      // onClick={gets}
                      placeholder={"Select Sub Group"}
                      required
                      options={watch("subCategoryDD")}
                      multi
                    />
                  </Col> */}
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Price"
                      name="price"
                      placeholder="Enter price"
                      required
                      min={0.01}
                      validation={{
                        validate: (value) => {
                          if (value <= 0) return "Price must be greater than 0";
                          return true;
                        },
                      }}
                    />
                  </Col>

                  <Col md={4}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Type"}
                      name={"discount_type"}
                      placeholder={"Select type"}
                      required
                      options={[
                        { value: "percentage", label: "percentage" },
                        { value: "fixed", label: "fixed" },
                      ]}
                    />
                  </Col>

                  <Col md="4" className={``}>
                    <DiscountValidation
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Discount"}
                      name={"discount"}
                      placeholder={"Enter discount"}
                      required
                      minNum={0} 
                     
                      validate={(value) => {
                        const type = watch("discount_type")?.value;
                        const price = watch("price");

                        if (!value) return true; 

                        const discountValue = parseFloat(value);
                        const priceValue = parseFloat(price);

                        if (isNaN(discountValue)) return "Please enter a valid number";

                        if (!price || isNaN(priceValue) || priceValue <= 0) {
                          return "Please enter a valid price first";
                        }

                        if (type === "percentage") {
                          if (discountValue < 0) return "Percentage cannot be negative";
                          if (discountValue > 100) return "Percentage cannot exceed 100%";

                          // Calculate actual discount amount
                          const discountAmount = (priceValue * discountValue) / 100;
                          if (discountAmount >= priceValue) {
                            return "Discount amount must be less than price";
                          }
                        } else if (type === "fixed") {
                          if (discountValue < 0) return "Discount cannot be negative";
                          if (discountValue >= priceValue) {
                            return "Fixed discount must be less than price";
                          }
                        } else {
                          return "Please select a discount type first";
                        }

                        return true;
                      }}
                    />
                  </Col>
                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Net"}
                      name={"net"}
                      placeholder={"Auto-calculated"}
                      readOnly
                      disabled
                    />
                  </Col>

                  {/* <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Minimum Amount"}
                      name={"min_amount"}
                      placeholder={"Enter minimum amount to avail coupon"}
                      required
                      min={1}
                      max={3}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Maximum Discount"}
                      name={"max_discount"}
                      placeholder={"Enter maximum discount to avail"}
                      required
                      min={1} 
                    />
                  </Col> */}
                  {/* <Col md="2" className={``}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Start Date"}
                      name={"start_date"}
                      placeholder={"Enter start date"}
                      required
                      min={moment().add(0, "days").toDate()}
                      max={moment().add(1, "years").toDate()}
                      time
                      format={"MM/dd/yyyy h:mm aa"}
                    />
                  </Col> */}
                  {/* <Col md="2" className={``}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Expiry Date"}
                      name={"exp_date"}
                      placeholder={"Enter expiry date"}
                      required
                      min={moment().add(1, "days").toDate()}
                      max={moment().add(1, "years").toDate()}
                      time
                      format={"MM/dd/yyyy h:mm aa"}
                    />
                  </Col> */}

                  {/* <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                      multi
                    />
                  </Col> */}

                  <Col md="4" className="">
                    <ImageUpload
                      name="package_image"
                      id="package_image"
                      watch={watch}
                      label="Upload Package Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="package_img"
                      setError={setError}
                      image_url="package_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Pacakge Details"
                      name="package-detail"
                      placeholder="Enter package details"
                      required
                    />
                  </Col> */}
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="package_description"
                      placeholder="Enter description"
                      required
                    />
                  </Col>

                  <Col md="4" className="">
                    <Status
                      register={register}
                      watch={watch}
                      // name={"status"}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      required
                    />
                  </Col>
                </Row>{" "}
                <Col md="3">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Package List" isLoading={isLoading} resetF={resetF}/>
        </Block>
      </Content>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={isLoading}
      />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />

      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default Package;

